
import { useState } from 'react';
import question from '../assets/kosci/question.png';
import jeden from '../assets/kosci/jeden.png';
import dwa from '../assets/kosci/dwa.png';
import trzy from '../assets/kosci/trzy.png';
import cztery from '../assets/kosci/cztery.png';
import piec from '../assets/kosci/piec.png';
import szesc from '../assets/kosci/szesc.png';

import arkuszRzutKoscmi from '../assets/files/arkusze/inf04RzutKoscmi.pdf';

import './DiceGame.css';

function Dice({value}){

  // zamiana liczby na obrazek
  function getDices(diceNumber){
    let src = "";
    switch (diceNumber){
      case 6 :
        src = szesc;
        break;
      case 5 :
        src = piec;
        break;
      case 4 :
        src = cztery;
        break;
      case 3:
        src = trzy;
        break;
      case 2:
        src = dwa;
        break;
      case 1:
        src = jeden;
        break;
      case 0 :
        src = question;
          break;
      default:
        src = question;
    }
    return src;
  }
  

  return (
    <div>
      <img className="diece-game-img" src={getDices(value)}  alt="dice" />
    </div>
  );
}
  
export default function DiceGame() {
  // tablica wyników losowania poszczególnych kości
  // 0 - question mark - na początku 
  const [dices, setDices] = useState(Array(5).fill(0))
  
  // wynik gry
  const[gameResult, setGameResult] = useState(0);
  
  // wynik bieżącego losowania
  const[drawResult, setDrawResult] = useState(0);

  // rzut kośćmi
  const rzuc = ()=>{
    let currentDrawResult = 0;        // wynik bieżącego losowania
    const tmpDices = dices.slice();
    for (let index = 0; index < dices.length; index++) {
      tmpDices[index] = losuj(); 
    }
    setDices(tmpDices)
    currentDrawResult = wynikLosowania(tmpDices);
    setDrawResult(currentDrawResult);
    //setDrawResult(wynikLosowania(tmpDices));     // działa
    setGameResult(gameResult + currentDrawResult);
    //setGameResult(gameResult + drawResult);   // nie działa
  }

  // przycisk reset
  const reset = ()=>{
    // resetowanie zmiennej stanu dices
    const tmpDices = dices.slice();
    for (let index = 0; index < dices.length; index++) {
      tmpDices[index] = 0; 
    }
    setDices(tmpDices);
    setDrawResult(0);
    setGameResult(0);
  }

  // funkcja losująca
  function losuj(){
    // 1 - 6 
    // 0 - question mark - nie można go wylosować
    return Math.floor(Math.random() * 6) + 1;
  }

  // liczymy wynik losowania
  function wynikLosowania(tmpDices){
    // tablica z ilością wylosowanych oczek
    // index 0 - ile wylosowano jedynhek
    // index 1 - ile wylosowano dwójek
    let wynikLos = [0,0,0,0,0,0];
    let drawResult = 0;     // wynik sumowania oczek
                            // sumujemy tylko powtarzające sie oczka
    let index = 0;          // index pomocniczy
   
    // liczbe wyrzuconych oczek zapisujemy w tablicy wynikLos[]
    // tmpDices [1,3,4,4,6,5]  - wylosowana liczba jest indeksem w tablicy wynikLos[]
    for (let i = 0; i < tmpDices.length; i++) {
        index = tmpDices[i] - 1;    // przesuniecie indeksu - od zera
        wynikLos[index]++           // ilość wylosowanego oczka
        if(wynikLos[index]>2){      // sumowanie oczek
          drawResult += (index + 1)
        }else if(wynikLos[index]>1){
          drawResult += wynikLos[index]*(index + 1)
        }
        //console.log("i:" + i + " wyniklos:" + wynikLos + " drawResult: " + drawResult);
    }
    //console.log("--------------");
    return drawResult;
  }



  return (
    <div>
      <div id="dice-game-container">
        <div id="dice-game-header1">
          Gra w kości
        </div>
        <div id="dice-game-header2">
          Kości zostały rzucone...
        </div>
        <div className="dice-game-btn-div">
          <button className="dice-game-button" onClick={rzuc}>RZUĆ KOSĆMI</button>
        </div>
        <div id="dices">
          <div className="dice"><Dice value = {dices[0]} /></div>
          <div className="dice"><Dice value = {dices[1]} /></div>
          <div className="dice"><Dice value = {dices[2]} /></div>
          <div className="dice"><Dice value = {dices[3]} /></div>
          <div className="dice"><Dice value = {dices[4]} /></div>
        </div>
        <p className='dice-game-p'>wynik tego losowania {drawResult}</p>
        <p className='dice-game-p'>wynik gry {gameResult}</p>
        <div className="dice-game-btn-div">
          <button className="dice-game-button" onClick={reset}>RESETUJ WYNIK</button>
        </div>
        <p className='dice-game-p'>
            <a href={arkuszRzutKoscmi}>arkusz Rzut Kośćmi</a>
        </p>
      
      </div>
      
    </div>
  );
}

